<div class="order-column container-fluid">
  <div class="row g-0">
    <div class="col">
      <app-order-common-row-view [data]="data"></app-order-common-row-view>
    </div>
  </div>
  <div class="row g-0">
    <div class="col">
      <app-order-details-row-view [data]="data"></app-order-details-row-view>
    </div>
  </div>
</div>